export default {"src":"/_next/static/media/Mastercard.827d37b6.svg","height":36,"width":53,"blurWidth":0,"blurHeight":0};